import React from 'react'

import Base from '../_Base'

const WatchlistNew = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="m17 18.113-3.256-2.326A2.989 2.989 0 0 0 12 15.228c-.629 0-1.232.194-1.744.559L7 18.113V4h10v14.113zM18 2H6a1 1 0 0 0-1 1v17.056c0 .209.065.412.187.581a.994.994 0 0 0 1.394.233l4.838-3.455a1 1 0 0 1 1.162 0l4.838 3.455A1 1 0 0 0 19 20.056V3a1 1 0 0 0-1-1z" />
    <circle stroke="#213944" fill="#f37522" cx="19" cy="5" r="4.5" />
  </Base>
)

export default WatchlistNew
